import React, { Component, Fragment } from 'react';
import { Row, Col, Button, Label } from "reactstrap";
import { inject, observer } from "mobx-react";
import { toJS } from 'mobx';
import InputText from '../../comum/tables/components/inputs/InputText';
import CheckboxField from '../../comum/components/CheckboxField';
import { IconeDelete, IconeSoma } from '../../comum/components/Icones';
import InputSelect from '../../comum/tables/components/inputs/InputSelect';
import AddServicosAcessorios from './AddServicosAcessorios';
import { E_CONDICAO, E_TIPO_CLIENTE, E_TIPO_TELA } from '../stores/Enum';
import ServicosAcessoriosPopOver from './ServicosAcessoriosPopOver';
import { terminal as TERMINAL } from '../../../config/Constantes';

@inject("store")
@observer
export default class DetalhesImpBlCntr extends Component {
    constructor(props) {
        super(props)

        this.dataStore = this.props.controllers.dataStore;
        this.viewStore = this.props.controllers.viewStore;
        this.filterStore = this.props.controllers.filterStore;
        this.impStore = this.props.controllers.impStore;
        this.appStore = this.props.store.appStore;
        this.modalStore = this.props.store.modalStoreCustom;        
    }
    
    numberHandler = (blIndex, index) => ({ target }) => {
        let newValue = '';

        const numberValue = parseInt(target.value.replace(/\D/gm,''), 10);
        if (!isNaN(numberValue)) newValue = numberValue;

        this.impStore.setItemBl(target.name, newValue, blIndex, index)
    }

    render() {
        const { item: { QtdContainer, Tipo, Status, TipoCntr, Refrigerada, Especial, Imo, Vistoria, PesoDocumental, MetragemDocumental, Erros }, index, blIndex, showDelete } = this.props;

        const temArmador = this.filterStore.tipoCliente == E_TIPO_CLIENTE.Armador;

        const permiteMultiplosCntr = !temArmador && this.impStore.showOptionHouse;
        const showTitle = this.appStore.isMobile || (permiteMultiplosCntr && index == 0) || (blIndex == 0 && index == 0);

        const servicosAcessoriosPorItem = this.impStore.getServicosIncluidosPorIndex(blIndex, index).filter(s => s.Basico == E_CONDICAO.Nao);

        return (
            <Row className="w-100 mb-2" >
                {this.impStore.showOptionHouse && ( 
                    <InputText xs={6} sm={6} md={3} lg={1} xl={1}
                        title={showTitle ? "Qtd." : ""}
                        noTitle={!showTitle}
                        name="QtdContainer"
                        value={QtdContainer}
                        onChange={this.numberHandler(blIndex, index)}
                        className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        disabled={this.viewStore.servicosAtivo}
                        error={Erros['QtdContainer']}
                    />
                )}
                <InputSelect xs={12} sm={12} md={6} lg={2} xl={2}
                    title={showTitle ? "Tipo" : ""}
                    noTitle={!showTitle}
                    name="Tipo"
                    isClearable={false}
                    options={toJS(this.impStore.opcoesTiposContainer.value)}
                    onChange={opt => this.impStore.setItemBl('Tipo', opt ? opt : null, blIndex, index)}
                    value={Tipo ? this.impStore.opcoesTiposContainer.value.find(o => o.value == Tipo.value) : null}
                    disabled={this.viewStore.servicosAtivo}
                    loading={this.impStore.opcoesTiposContainer.loading}
                    className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                    error={Erros['Tipo']}
                />
                {temArmador && 
                    <InputSelect xs={12} sm={12} md={6} lg={2} xl={2}
                        title={showTitle ? "Status" : ""}
                        noTitle={!showTitle}
                        name="Status"
                        options={toJS(this.impStore.opcoesStatusContainer.value)}
                        onChange={opt => this.impStore.setItemBl('Status', opt ? opt : null, blIndex, index)}
                        value={Status ? this.impStore.opcoesStatusContainer.value.find(o => o.value == Status.value) : null}
                        disabled={this.viewStore.servicosAtivo}
                        loading={this.impStore.opcoesStatusContainer.loading}
                        className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        error={Erros['Status']}
                    />                        
                }
                {this.impStore.showOptionHouse && (
                    <Fragment>
                        <InputSelect xs={12} sm={12} md={6} lg={2} xl={2}
                            title={showTitle ? "Tipo Cntr" : ""}
                            noTitle={!showTitle}
                            name="TipoCntr"
                            isClearable={false}
                            options={this.impStore.opcoesTipoCntrFiltradasPorIndex(blIndex, index)}
                            onChange={opt => this.impStore.setItemBl('TipoCntr', opt ? opt : null, blIndex, index)}
                            value={TipoCntr ? this.impStore.opcoesTipoCntr.value.find(o => o.value == TipoCntr.value) : null}
                            disabled={this.viewStore.servicosAtivo}
                            loading={this.impStore.opcoesTipoCntr.loading}
                            className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                            error={Erros['TipoCntr']}
                        />
                    </Fragment>
                )}
                {this.impStore.showOptionPier && TERMINAL === "SSA" && (
                    <CheckboxField
                        widthAuto={true}
                        backgroundWhite={true}
                        titulo={showTitle ? "Refrigerada?" : ""}
                        noTitle={!showTitle}
                        text={"Sim"}
                        ativo={Refrigerada}
                        onClick={(value) => this.impStore.setItemBl('Refrigerada', value, blIndex, index)}
                        className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        bloqueado={this.viewStore.servicosAtivo}
                    />
                )}
                <CheckboxField
                    widthAuto={true}
                    backgroundWhite={true}
                    titulo={showTitle ? `Especial${TERMINAL === "RIG" ? '/Imo' : ''} ?` : ""}
                    noTitle={!showTitle}
                    text={"Sim"}
                    ativo={Especial}
                    onClick={(value) => this.impStore.setItemBl('Especial', value, blIndex, index)}
                    className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                    bloqueado={this.impStore.disableEspecialOption(blIndex, index) || this.viewStore.servicosAtivo}
                />
                {TERMINAL === "SSA" && (
                    <CheckboxField
                        widthAuto={true}
                        backgroundWhite={true}
                        titulo={showTitle ? "Imo?" : ""}
                        noTitle={!showTitle}
                        text={"Sim"}
                        ativo={Imo}
                        onClick={(value) => this.impStore.setItemBl('Imo', value, blIndex, index)}
                        className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        bloqueado={this.viewStore.servicosAtivo}
                    />
                )}
                {!temArmador && TERMINAL === "RIG" && (
                    <Fragment>
                        <CheckboxField
                            widthAuto={true}
                            backgroundWhite={true}
                            titulo={showTitle ? "Vistoria?" : ""}
                            noTitle={!showTitle}
                            text={"Sim"}
                            ativo={Vistoria}
                            onClick={(value) => this.impStore.setItemBl('Vistoria', value, blIndex, index)}
                            className={`pr-2 pl-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                            bloqueado={this.viewStore.servicosAtivo}
                        />
                        {this.impStore.showOptionPier && (
                            <Fragment>
                                <InputText xs={12} sm={12} md={6} lg={3} xl={3}
                                    title={showTitle ? "Tonelagem (Kg)" : ""}
                                    noTitle={!showTitle}
                                    name="PesoDocumental"
                                    value={PesoDocumental}
                                    onChange={this.numberHandler(blIndex, index)}
                                    className="pr-0 mb-0"
                                    disabled={this.viewStore.servicosAtivo}
                                    error={Erros['PesoDocumental']}
                                />
                                <InputText xs={12} sm={12} md={6} lg={3} xl={3}
                                    title={showTitle ? "Volume Cúbico (m³)" : ""}
                                    noTitle={!showTitle}
                                    name="MetragemDocumental"
                                    value={MetragemDocumental}
                                    onChange={this.numberHandler(blIndex, index)}
                                    className="pr-0 mb-0"
                                    disabled={this.viewStore.servicosAtivo}
                                    error={Erros['MetragemDocumental']}
                                />
                            </Fragment>
                        )}
                    </Fragment>
                )}
                {this.viewStore.servicosAtivo && this.impStore.showOptionHouse &&
                    <Col xs={12} sm={12} md={6} lg={2} xl={2} className="pb-2 d-flex align-items-end" >
                        <div className="w-100 d-flex flex-column">
                                {showTitle && <Label className="footer-select--label">Serviços</Label>}
                                <AddServicosAcessorios 
                                    className="collapseItem mr-3"
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Importacao}
                                    items={[this.impStore.getItem(blIndex, index)]}
                                >
                                    <IconeSoma tamanho="sm" />
                                </AddServicosAcessorios>
                            </div>
                        {servicosAcessoriosPorItem.length > 0 && (
                            <ServicosAcessoriosPopOver 
                                servicosAcessorios={servicosAcessoriosPorItem}
                                removeServico={this.impStore.removeServico}
                            />
                        )}
                    </Col>
                }
                {!this.viewStore.servicosAtivo && showDelete && (
                    <Col>
                        <div className="w-100 d-flex flex-column" style={showTitle ? { paddingTop: "28px" } : {}} >
                            <Button
                                className="collapseItem"
                                outline
                                onClick={() => this.impStore.removeItemBl(blIndex, index)}
                            > 
                                <IconeDelete tamanho="sm" />
                            </Button>
                        </div>
                    </Col>
                )}
            </Row>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/DetalhesImpBlCntr.js